import Layout from "../../components/Layout/Layout";
function Welcome(props) {
  return (
    <Layout {...props}>
      <div className="row gutters">
        <div
          className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ms-2"
        >
          <h4>Welcome</h4>
          <p>
            <strong>A note from the creator of Fale:</strong>
          </p>
          <div className="row me-4" style={{ marginLeft: "1px" }}>
            <div className="col-sm-12 col-lg-4 col-md-6">
              <div className="row bg-white p-2 rounded">
                <div className="col-5">
                  <img
                    src="assets/img/tino.jpg"
                    className="rounded-pill"
                    style={{ width: "90px" }}
                    alt="tino"
                  />
                </div>
                <div className="col-7">
                  <p className="mt-2">
                    <strong>Name: </strong>Tino Laomahei
                  </p>
                  <p>
                    <strong>Phone: </strong>021 166 1034
                  </p>
                  <p>
                    <strong>Email: </strong>tino@fale.co.nz
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="mt-2">Hi {props.currentUser?.first_name || "there"},</p>

          <p>
            My name is Tino and I am a New Zealand born Tongan/Māori and senior
            software developer based in Hillsborough, Auckland, New Zealand.
          </p>
          <p className="mt-2">
            I am the founder and sole developer of the Fale Marketplace. I built
            this system during my holiday away from work where I write code
            professionally for multiple start ups across New Zealand and the US.
          </p>
          <p className="mt-2">
            I've been writing code professionally for over 10 years and have
            been building software products in my spare time.
          </p>
          <p className="mt-2">Fale is one of those products.</p>
          <p>
            My family and I believe that the food that is sold out of local
            kitchens are way better than what's on Uber Eats right now, which is
            one of the core reasons I started this project.
          </p>
          <p className="mt-2">
            I came up with the idea for Fale with one of my brothers a few
            months ago when we were hungry for some homemade Tongan food. If we
            can't be bothered making our own Tongan food, we usually head over
            to Facebook Marketplace and hope that someone, somewhere is cooking
            and selling it!
          </p>
          <div className="mt-2">
            So what are the problems we see with this?
            <br />
            <br />
            As a customer:
            <br />
            <ol>
              <li>We didn't know which kitchens were open</li>
              <li>We didn't know what products were available</li>
              <li>
                Sometimes we had to wait ages to get a reply from the kitchens
              </li>
              <li>
                When we did make an order, we were left in the dark on the
                status of our order
              </li>
            </ol>
            So what does this translate to for you as a kitchen?
            <br />
            <ol>
              <li>Time wasted with back and forth between customers</li>
              <li>
                Manual order management/tracking, having to rely on messaging or
                memory
              </li>
              <li>
                Getting messages when you're not open and no way to go offline
              </li>
              <li>Customers changing their mind before payment</li>
            </ol>
          </div>
          <p>
            We're hoping Fale can fix these problems and more for both you and
            your customers.
          </p>

          <p className="mt-2">
            If you're willing to join me on the journey of bringing back home
            cooked meals, 1 kitchen at a time, don't hesitate to send me
            feedback about the platform and how I can improve the experience for
            you and your customers.
          </p>
          <p className="mt-2">
            Thanks again for joining Fale and I look forward to working with
            you!
          </p>
          <p className="mt-2">Cheers,</p>
          <p className="mt-2">Tino.</p>
          <br />
          <br />
          <br />

          {/* <p>Frequently Asked Questions</p>
          <div class="accordion accordion-flush" id="accordion">
            {questions.map((question, index) => (
              <div key={`question${index}`} class="accordion-item">
                <h2 class="accordion-header" id={`heading${index}`}>
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false"
                    aria-controls={`collapse${index}`}
                  >
                    {question.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  class="accordion-collapse collapse"
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordion"
                >
                  <div class="accordion-body">{question.answer}</div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </Layout>
  );
}

export default Welcome;
